import React from "react";
import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Controller } from "react-hook-form";
import { ContactTheRegulator } from "../../domain/ContactTheRegulator";
import { SectionProps } from "./SectionProps";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import { Error } from "../common/Error";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import { AttachmentList } from "./AttachmentList";
import { contactTheRegulatorService } from "../../services";

export const MessageDetails: React.FC<SectionProps<ContactTheRegulator>> = ({
  control,
  errors,
  disabled,
  user: { token },
  item,
}) => {
  const download = (blobId: string) =>
    contactTheRegulatorService.downloadCtrAttachment(item?.id!, blobId, {
      token,
    });
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="title"
          rules={{ required: true }}
          as={
            <TextField
              label="Title"
              data-test="ctr-title"
              fullWidth
              readOnly={disabled}
              required
            />
          }
        />
        {errors.title?.type === "required" && (
          <Error data-test="ctr-title-error">This field is required</Error>
        )}
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="messageBody"
          rules={{ required: true }}
          render={({ onChange, value }) => (
            <>
              <label>Message {disabled ? "(Read Only)" : ""} *</label>
              <MarkdownEditor
                onChange={onChange}
                value={value}
                readOnly={disabled}
                dataTest="new-message-field"
              />
            </>
          )}
        />
        {errors.messageBody?.type === "required" && (
          <Error data-test="new-message-field-error">This field is required</Error>
        )}
      </Grid>
      {!disabled ? (
        <Grid item xs={12}>
          <Controller
            control={control}
            name="files"
            as={<FileInput multiple={true} disabled={disabled} data-test="new-attachment-button" />}
          />
        </Grid>
      ) : (
        <>
          {item?.ctrAttachments.length ? (
            <>
              <label>Attachments</label>
              <br /> <br />
              <AttachmentList
                attachments={item?.ctrAttachments!}
                download={download}
              />
            </>
          ) : null}
        </>
      )}
    </Grid>
  );
};
